
<template>
  <div class="home">
    <div class="main-wrap">
      <AppBar />

      <div :key="'home' + $vuetify.breakpoint.name">
        <div class="container-wap">
          <section id="home">
            <Banner />
          </section>

          <section style="z-index: 2" id="features">
            <HorizontalFeatures />
          </section>

          <!-- <section :class="!isMobile && 'space-top-short'"><counter /></section> -->

          <div class="relative">
            <div class="decoration absolute">
              <svg>
                <use :xlink:href="$asset('/images/saas/deco-bg.svg#main')" />
              </svg>
            </div>

            <section class="relative space-top-short" style="z-index: 2">
              <v-fade-transition hide-on-leave>
                <Features />
              </v-fade-transition>
            </section>
          </div>

          <!-- <section id="showcase"><Showcase /></section> -->

          <!-- <section id="testimonials" class="space-bottom-testi">
            <Testimonials />
          </section> -->

          <section id="pricing" class="space-top-short relative" style="z-index: 1">
            <PricingPlans class="relative" />
            <br />
          </section>

          <!-- <section id="faq" class="space-top-short">
            <Faq :items="$store.state.faq" />
          </section> -->

          <!-- <section class="space-top-short space-bottom-short"><News-Event /></section> -->
        </div>
        <section id="footer" style="z-index: 2">
          <FooterWithDeco />
        </section>

        <hidden point="mdDown">
          <PageNav />
        </hidden>
        <!-- <hidden point="mdDown">
          <Notification />
        </hidden> -->
      </div>
    </div>
  </div>
</template>

<script>
import PricingPlans from "@/landing/components/PricingPlans";
import HorizontalFeatures from "../../components/HorizontalFeatures/HorizontalFeatures";
import PageNav from "@/landing/components/PageNav";
import AppBar from "@/landing/components/Header/AppBar";
import Banner from "@/landing/components/Banner";
import Features from "@/landing/components/Features/Features.vue";
import Faq from "@/landing/components/Faq";
import FooterWithDeco from "@/landing/components/Footer/FooterWithDeco";

export default {
  components: {
    AppBar,
    Banner,
    Features,
    Faq,
    FooterWithDeco,
    PageNav,
    HorizontalFeatures,
    PricingPlans,
  },

  data() {
    return {
      mounted: false,
    };
  },

  created() {
    this.handleAnchorLink();
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },

  watch: {
    $route(newValue, oldValue) {
      if (newValue.name === "welcome") this.handleAnchorLink();
    },
  },

  methods: {
    handleAnchorLink() {
      let hashTarget = this.$route.hash;
      if (!hashTarget) {
        let anchor = this._.get(this.$route, ["query", "anchor"]);
        if (anchor) hashTarget = "#" + anchor;
      }
      if (!hashTarget) return;

      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
      });

      this.$nextTick().then(
        this.$nextTick(() => {
          const targetElement = document.querySelector(hashTarget);
          if (!targetElement) return;
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });

          // this.$route.hash = hashTarget;
        }),
      );
    },
  },
};
</script>

<style scoped>
section {
  position: relative;
}
</style>

<style lang='scss'>
@import "@/landing/dependencies.scss";

.home .decoration {
  z-index: 1;
  position: absolute;
  width: 1280px;
  height: 100%;
  @include left(-10px);
  top: 100px;
  svg {
    width: 100%;
    height: 1700px;
    @include use-theme(fill, $palette-primary-light, $palette-primary-dark);
    opacity: 0.15;
    @include breakpoints-down(xs) {
      transform: scale(0.5);
      transform-origin: center left;
    }
    @include breakpoints-up(sm) {
      transform: scale(1.6);
    }
    @include breakpoints-up(md) {
      transform: scale(2.7, 1);
    }
    @include breakpoints-up(lg) {
      transform: scale(2.7, 1);
    }
    @include breakpoints-up(xl) {
      transform: scale(2.7, 1);
    }
  }
}
</style>

